import { ActionMenuLink, stenaMail } from "@stenajs-webui/elements";
import type { FC } from "react";

import type { BasicBooking } from "../../../../../common/graphql/fragments/gql/BasicBooking";
import { useLocalDateFormat } from "../../../../../common/hooks/useLocalDateFormat";
import { getMailUrl } from "./util/options-table-cell-utils";

interface MailBookingActionMenuItemProps {
  booking: BasicBooking;
  disabled?: boolean;
  onClick: () => void;
}
export const MailBookingActionMenuItem: FC<MailBookingActionMenuItemProps> = ({
  disabled,
  booking,
  onClick,
}) => {
  const dateFormat = useLocalDateFormat();

  return (
    <ActionMenuLink
      label={"Send as mail"}
      href={getMailUrl(booking, dateFormat)}
      leftIcon={stenaMail}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
